import DialogManager from '../functions/dialog.js';
import { generateTemplateContent, parseToHtml, replaceString } from '../functions/html_element.js';
import { setCacheData, getCacheData } from '../functions/cache.js';
import { initGlobalComponents } from '../modules/global-components.js';
import { initProductListsNearViewport } from '../modules/product_list_module.js';

$(function(){

    try {
        initGlobalComponents();
        initProductListsNearViewport();

    } catch (error) {
        console.error('Erro ao inicializar os componentes da página inicial:', error);
    }
})
